import request from '@/router/axios';

let urlPrefix = '/api/lab/labexperimentlog';

/**
 * 课堂实验日志
 * @param data
 */
export const add = (data) => {
    return request(urlPrefix, { data }, 'post')
}

/**
 * 查看全部日志    /labexperimentlog/all
 */
export const getAllExpLog = () => {
    return request(`${urlPrefix}/all`);
}

/**
 * /labexperimentlog/query
 */
export const getExpLogList = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}

/**
 * /labexperimentlog/getLabExpTotalTS
 */
export const getLabExpTotalTS = (data) => {
    return request(`${urlPrefix}/getLabExpTotalTS`, {
        data
    }, 'post')
}


// /labexperimentlog/getCountGroupByDay
export const getStudyLog = params => {
    return request(`${urlPrefix}/getCountGroupByDay`, {
        params: {
            ...params
        },
        methods: 'get'
    });
};
